// Import dependencies
import { html, LitElement } from 'lit';
import { until } from 'lit/directives/until.js';
import { customElement, query, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
const { isEmpty, htmlEntities } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.token;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-token-edit-dialog' )
export class AutomatorBuilderItemTokenEditDialog extends LitElement {
	// Properties
	// The token code
	@property( { type: String, attribute: 'token-code' } ) accessor tokenCode;

	// The code of the integration
	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	// The condition fields
	@property( { type: Object, attribute: false } ) accessor fields = {};

	// Returns the component that has the fields of this filter condition
	// We'll use it to retrieve the values
	@query( 'uap-builder-item-legacy-form' ) accessor $optionsForm;

	/**
	 * Disable the shadow DOM
	 *
	 * @todo Remove this method once fields become web components. This component should be using the shadow DOM.
	 * @return {Element} The element
	 */
	createRenderRoot() {
		return this;
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-dialog
				heading=${ strings.tokenData }

				size="large"
				force-manual-close
				open

				@uap-dialog-close=${ this.handleDialogClose }
			>
				${ this._templateFields }

				<uo-button
					slot="primary-action"

					@click=${ this.handleConfirmEdit }
				>
					${ strings.confirm }
				</uo-button>

				<uo-button
					slot="secondary-action"
					dialog-action="close"
					color="secondary"
				>
					${ strings.cancel }
				</uo-button>
			</uo-dialog>
		`;
	}

	/**
	 * Returns the fields of the template
	 *
	 * @return {TemplateResult} The TemplateResult of the fields
	 */
	get _templateFields() {
		return html`
			<uap-builder-item-legacy-form
				item-type="token"

				.fieldsDirectory=${ this.directoryItemData.fields }
				.fieldsValues=${ this.fields }

				return-format="token"

				@uap-builder-legacy-form-change=${ ( event ) => {
					// Update the fields, even if they are not saved yet
					// The cancel button will revert the changes, and the save button will save them
					this.fields = event.detail.unsavedFieldValues;
				} }
			></uap-builder-item-legacy-form>
		`;
	}

	/**
	 * Handles updating the filter data on the server
	 *
	 * @return {Promise|undefined} The promise that either updates or creates the filter condition
	 */
	handleConfirmEdit() {
		// Check if the fields are available
		if ( isEmpty( this.$optionsForm ) ) {
			return;
		}

		// Validate the form
		if ( ! this.$optionsForm.areFieldsValid ) {
			return;
		}

		// Dispatch save event
		this.dispatchEvent( new CustomEvent(
			'uap-builder-item-token-saved-successfully',
			{
				detail: {
					unsavedFieldValues: this.$optionsForm.unsavedFieldValues
				}
			}
		) );

		// Delete this component
		this.handleDialogClose();
	}

	/**
	 * Returns the global/directory data of this item
	 *
	 * @return {Object} The directory data of this item. This contains, for example, the fields attributes
	 */
	get directoryItemData() {
		return UncannyAutomator._core.directory.items.token.getUniversalToken(
			this.integrationCode,
			this.tokenCode
		);
	}

	/**
	 * Returns the global/directory data of the integration of this filter condition
	 *
	 * @return {Object} The directory data of this filter condition. Contains, for example, the name of the integration.
	 */
	get directoryIntegrationData() {
		return UncannyAutomator._core.directory.integrations.getIntegration( this.integrationCode );
	}

	/**
	 * Delete this component when something closes the dialog
	 */
	handleDialogClose() {
		this.remove();
	}
}